export default __webpack_public_path__ + "static/logo-3-ba3330459e2238c3a98e9b682413a108.webp";